import(/* webpackMode: "eager" */ "/vercel/path0/apps/studio-web/app/global-error.tsx");
